import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetch, openApiFetchDelete } from '../../../store/openApiFetch';
import { useOpenApiFetch } from '../../../store/useOpenApiFetch';
import { EditPanelMarkdown } from '../../common/markdown/EditPanelMarkdown';
import { PanelBody, EditPanelRow, EditPanelCell, EditPanelButton } from '../../elements';
import { Comment } from '../workflow/Comment';

export function SurveyEditSurveyComments(props: { surveyId: string }) {
    const { surveyId } = props;
    const translate = useTranslate();
    const [text, setText] = React.useState('');
    const { data, reload } = useOpenApiFetch('/api/surveys/{surveyId}/comments', 'get', { surveyId }, []);

    async function createComment() {
        await openApiFetch('/api/surveys/{surveyId}/comments', 'post', { surveyId }, { text });
        setText('');
        await reload();
    }

    async function deleteComment(commentId: string) {
        await openApiFetchDelete('/api/surveys/{surveyId}/comments/{commentId}', { surveyId, commentId });
        await reload();
    }

    return (
        <PanelBody isForm={true}>
            <EditPanelRow>
                <EditPanelCell rowCount={9}>
                    <EditPanelMarkdown
                        value={text}
                        handleChange={(value) => setText(value)}
                        name="text"
                        placeholder={translate('workflow.comment')}
                        size="small"
                        hasTableEditor={false}
                    />
                </EditPanelCell>
                <EditPanelCell rowCount={3}>
                    <EditPanelButton primary text={translate('workflow.addComment')} onClick={createComment} iconClass="fa fa-save" small />
                </EditPanelCell>
            </EditPanelRow>
            {data && data.length > 0 && (
                <div className="bg-light darker pn">
                    {data.map((comment) => (
                        <Comment
                            key={comment.id}
                            id={comment.id}
                            commentedBy={comment.commentedBy}
                            commentedOn={comment.commentedOn}
                            text={comment.text}
                            onDeleted={comment.permissions.canDelete ? deleteComment : null}
                            shouldDisplayAsMarkdown
                        />
                    ))}
                </div>
            )}
        </PanelBody>
    );
}
